import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';

import EasyJoinConfirmation from '../presentational/EasyJoinConfirmation';
import Logo from '../../../../shared/images/full-logo-black-orange.png';
import SubText from '../../../../shared/_TBComponents/SubText';

const FormArea = styled('div')`
  display: flex;
  flex-direction: column;
  height: auto;
  padding: 30px 54px;
  position: relative;
  
  @media screen and (max-width: 600px) {
    padding: 30px;
  }
`;

const FormContainer = styled('div')`
  background-color: white;
  height: auto;
  padding-bottom: 40px;
  width: 430px;

  @media screen and (max-width: 600px) {
    height: auto;
    padding-bottom: 20px;
    width: 330px;
  }
`;

const TitleArea = styled('div')`
  align-items: center;
  border-bottom: 2px solid rgb(232, 232, 232);
  display: flex;
  flex-direction: column;
  height: 160px;
  justify-content: center;
  padding: 30px 80px 5px 80px;
  width: 100%;

  img {
    margin-bottom: 20px;
  }

  @media screen and (max-width: 600px) {
    height: 135px;
  }
`;

const EasyJoinConfirmationContainer = () => {
  const isEasyJoinCompleted = useSelector((state) => state.registration.data.isEasyJoinCompleted);

  const dispatch = useDispatch();

  // Redirect user if they accessed the route directly and didn't submit an easy join code
  useEffect(() => {
    if (!isEasyJoinCompleted) {
      dispatch(push('/signup/easy-join'));
    }
  }, [isEasyJoinCompleted]);

  return (
    <FormContainer>
      <TitleArea>
        <img
          alt='Teambuildr'
          className='img-fluid'
          src={Logo}
        />
        <SubText>
          Easy Join
        </SubText>
      </TitleArea>
      <FormArea>
        <EasyJoinConfirmation />
      </FormArea>
    </FormContainer>
  );
};

export default EasyJoinConfirmationContainer;
